var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"svg-button",style:({
      'margin-left' : _vm.marginLeft + 'px',
      'margin-right' : _vm.marginRight + 'px',
      'width' : _vm.buttonWidth + 'px',
      'height': _vm.buttonHeight + 'px',
      'z-index' : '20'
  }),attrs:{"flat":"","ripple":false}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aa4c5da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/shared/SvgButton.vue
// module id = null
// module chunks = 